export default "__VITE_ASSET__Ds7i3_q0__"